import {
  FETCH_ITEMMASTER_BRAND_SUCCESS_ACTION,
  FETCH_ITEMMASTER_UNIT_SUCCESS_ACTION,
  FETCH_ITEMMASTER_MEDICALTYPE_SUCCESS_ACTION,
  FETCH_ITEMMASTER_SUCCESS_ACTION,
  FETCH_ALLBRANDS_SUCCESS,
} from "./action";

const initialState = {
  processing: false,
  error: false,
};

export default function (state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_ITEMMASTER_SUCCESS_ACTION:
      return {
        ...state,
        ItemMasterDtlsList: action.payload.rows,
        ItemMasterDtlsCount: action.payload.count,
      };

    case FETCH_ITEMMASTER_BRAND_SUCCESS_ACTION:
      console.log(action.payload.rows);
      return {
        ...state,
        BrandList: action.payload.rows,
      };
    case FETCH_ITEMMASTER_UNIT_SUCCESS_ACTION:
      return {
        ...state,
        UnitList: action.payload.rows,
      };

    case FETCH_ITEMMASTER_MEDICALTYPE_SUCCESS_ACTION:
      return {
        ...state,
        MedicalTypeList: action.payload.rows,
      };

    case FETCH_ALLBRANDS_SUCCESS:
      return {
        ...state,
        allBrands: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
}
